import {login, logout} from "../store/userSlice";
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.gashtalt.ir',
    //baseURL: 'http://localhost:8000',
});

// Add a request interceptor to dynamically set the Authorization header
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Or wherever you store the token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete config.headers.Authorization; // Remove the Authorization header if no token
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


const fetchUserProfile = async (dispatch) => {
    try {
        const response = await api.get('api/refreshToken', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, // Replace with token storage logic
        });

        // Update the token in Redux or local storage
        dispatch(
            login({
                user: response.data.data.user,
                token: response.data.data.token,
            })
        );

        localStorage.setItem('token', response.data.data.token); // Update token in storage
        return response.data.data.token; // Return the new token
    } catch (error) {
        throw error; // Let the interceptor handle it
    }
};
export {api}
